export default "__VITE_ASSET__DGvIPXeD__"